export default __webpack_public_path__ + "static/media/gallery-wip-pommel-cap_05.6a97512a.jpg";